import { Button } from '@mui/material';
import * as React from 'react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import styled from 'styled-components';
import { brandingColourHeavyLight, tabletPortraitMinWidth } from '../appComponents/cssConstants';

const PrimaryButton = ({
	type = 'button',
	text = 'Submit',
	disabled = false,
	onClick = () => {},
	fullWidth = true,
	showArrowForwardIcon = false,
	className = '',
	lightColour = false
}: ButtonProps) => {
	return (
		<CustomButton
			type={type}
			variant="contained"
			className={className}
			endIcon={showArrowForwardIcon && <ArrowForwardIcon style={{ fontSize: 32, marginLeft: 10 }} />}
			onClick={onClick}
			$fullWidth={fullWidth}
			$lightColour={lightColour}
			disabled={disabled}
		>
			{text}
		</CustomButton>
	);
};

export default PrimaryButton;

export interface ButtonProps {
	type?: 'submit' | 'reset' | 'button';
	fullWidth?: boolean;
	showArrowForwardIcon?: boolean;
	disabled?: boolean;
	text?: string;
	onClick?: () => void;
	className?: string;
	lightColour?: boolean;
}

export const FormPrimaryButton = styled(PrimaryButton)<{ $fullWidthInDesktop: boolean | null }>`
	@media (min-width: ${tabletPortraitMinWidth}) {
		display: ${(props) => ((props.$fullWidthInDesktop ?? props.fullWidth) ? 'flex' : 'inline-flex')} !important;
		width: ${(props) => ((props.$fullWidthInDesktop ?? props.fullWidth) ? '100%' : 'unset')} !important;
	}
`;

const CustomButton = styled(Button)<{ $fullWidth: boolean; $lightColour: boolean }>`
	display: ${(props) => (props.$fullWidth ? 'flex' : 'inline-flex')};
	height: 50px;
	width: ${(props) => (props.$fullWidth ? '100%' : 'unset')};
	border-radius: 7px;
	text-transform: none;
	font-size: 18px;
	font-weight: 400;
	background-color: ${(props) => (props.$lightColour ? brandingColourHeavyLight : props.theme.brandingColourHeavy)};
	opacity: 0.9;
	margin: 0 0 0 auto;
	line-height: 22px;
	min-width: 110px;

	&:hover {
		opacity: 1;
		background-color: ${(props) => props.theme.brandingColourHeavy};
	}
`;
